module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0025.jpg?v=e17ecac3";